import React from 'react';
import PropTypes from 'prop-types';

// Note: This is a `td` instead of a `th` for accessibility purposes.
// It's clearer to use the player's name as the only row header and leave the
// rank as a standard cell.
export const RankCell = ( { rank, ...cellProps } ) => (
    <td { ...cellProps } className="stats-leaders-table__row-header-cell">
        { rank }
    </td>
);

RankCell.propTypes = {
    rank: PropTypes.number.isRequired
};